import { AxiosResponse } from 'axios';
import { getApiUrl } from '../util/util';
import { get } from './http';

export interface ExternalServiceIntegrationResponse {
	externalServiceIntegrations: ExternalServiceIntegration[];
}

export interface AutofillIntegrationResponse {
	calls: AutofillCallResponse[];
}

export interface ExternalServiceIntegration {
	type: string;
	name: string;
	url: string;
	tenantLocator: string;
	headers: Headers;
}

export interface AutofillCallResponse {
	locator: string;
	operation: string;
	callSequence: [string];
}

export enum AutofillOperations {
	NEW_BUSINESS = 'newBusiness',
	ENDORSEMENT = 'endorsement',
	RENEWAL = 'renewal',
}

export enum AutofillOperationTypes {
	CREATE = 'create',
	UPDATE = 'update',
}

interface IntegrationsApi {
	fetchIntegrations(
		authorizationToken?: string,
	): Promise<AxiosResponse<ExternalServiceIntegrationResponse>>;
	fetchAutofillSequences(
		authorizationToken?: string,
	): Promise<AxiosResponse<AutofillIntegrationResponse>>;
}

export default {
	fetchIntegrations(authorizationToken) {
		return get(
			`${getApiUrl()}/integrations/frontEndPlugins`,
			authorizationToken,
		);
	},
	fetchAutofillSequences(authorizationToken) {
		return get(`${getApiUrl()}/integrations/autofill`, authorizationToken);
	},
} as IntegrationsApi;
